import React from 'react';
import { DropResult } from 'react-beautiful-dnd';

import { CmButton } from '@/components/uiParts';
import { UpdateMenuSet } from '@/pages/menu-managements/allocated-menus/service';
import { SearchBrandMenuResponse } from '@/services/BrandMenu/hooks/search/useMenuManagementBrandMenuSearch';
import { SearchBrandMenuHourResponse } from '@/services/BrandMenuHour/hooks/search/useMenuManagementBrandMenuHourSearch';

import { MenuManagementAllocatedMenusModalInner } from './MenuManagementAllocatedMenusModalInner';

type Props = {
  masterStoreIds: number[];
  brandMenuOptions: SearchBrandMenuResponse[];
  menuSets: UpdateMenuSet[];
  isOpen: boolean;
  brandMenuHourOptions: SearchBrandMenuHourResponse[];
  handleCloseModal: () => void;
  handleOpenModal: () => void;
  handleChangeBrandMenu: (index: number, brandMenuId: string) => void;
  handleChangeBrandMenuHour: (index: number, brandMenuHourId: string) => void;
  handleAddMenuSet: () => void;
  handleRemoveMenuSet: (brandMenuIndex: number) => void;
  handleBulkCreate: () => void;
  handleOnDragEnd: (result: DropResult) => void;
};

export const MenuManagementAllocatedMenusBulkRegisterModal: React.FC<Props> = ({
  masterStoreIds,
  brandMenuOptions,
  menuSets,
  isOpen,
  brandMenuHourOptions,
  handleCloseModal,
  handleOpenModal,
  handleChangeBrandMenu,
  handleChangeBrandMenuHour,
  handleAddMenuSet,
  handleRemoveMenuSet,
  handleBulkCreate,
  handleOnDragEnd,
}) => {
  return (
    <>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton
        isDisabled={masterStoreIds.length === 0}
        onClick={handleOpenModal}
        width={100}
        ml={4}
      >
        一括更新
      </CmButton>
      {isOpen && (
        <MenuManagementAllocatedMenusModalInner
          target="一括更新"
          handleSubmit={handleBulkCreate}
          {...{
            isOpen,
            brandMenuOptions,
            menuSets,
            brandMenuHourOptions,
            handleCloseModal,
            handleChangeBrandMenu,
            handleChangeBrandMenuHour,
            handleAddMenuSet,
            handleRemoveMenuSet,
            handleOnDragEnd,
          }}
        />
      )}
    </>
  );
};
